import store from '../store/store';
import { mutatorAction } from 'satcheljs';
import { GoDaddyDomainDetails } from '../contracts/GoDaddyDomainDetails';

export default mutatorAction('setGoDaddyDomainDetails', function setGoDaddyDomainDetails(
    response: GoDaddyDomainDetails
) {
    if (response !== null) {
        store.legacyPremiumUserDomainState.authCode = response.authCode;
        store.legacyPremiumUserDomainState.locked = response.locked;
        store.legacyPremiumUserDomainState.privacy = response.privacy;
    }
});
